export default __webpack_public_path__ + "static/SourceCodePro.normal-2adb72f4260fef95a3981d3f9a680097.woff";